"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PlayoutRequestReason;
(function (PlayoutRequestReason) {
    PlayoutRequestReason["New"] = "New";
    PlayoutRequestReason["NextAsset"] = "NextAsset";
    PlayoutRequestReason["Restart"] = "Restart";
})(PlayoutRequestReason = exports.PlayoutRequestReason || (exports.PlayoutRequestReason = {}));
var DefaultPlayerProvider = (function () {
    function DefaultPlayerProvider() {
    }
    DefaultPlayerProvider.prototype.getPlayoutRequestData = function (assetSignature, playoutRequestReason) {
        return Promise.resolve(this.currentPlayoutRequestData);
    };
    DefaultPlayerProvider.prototype.getNextAssetSignature = function (currentAssetSignature) {
        return Promise.resolve(null);
    };
    DefaultPlayerProvider.prototype.setCurrentPlayoutRequestData = function (currentPlayoutRequestData) {
        this.currentPlayoutRequestData = currentPlayoutRequestData;
    };
    return DefaultPlayerProvider;
}());
exports.DefaultPlayerProvider = DefaultPlayerProvider;
